import { FeathersModel } from './feathersModel'
import { User } from './user'

export class ClientAllocation extends FeathersModel {
  static serviceName = 'client-allocations'

  clientId: number
  allocationId: number
  keyWorkerUserId: number | null
  keyWorkerUser?: Partial<User>
  keyWorkerNote: string | null
  cooperationStartDate: string | null // TODO: or Date?
  contractedAssistanceMinutesPerWeek: number | null
  deactivatedAt: Date | null
  deactivationReason: string | null
}
